import React, { Component } from 'react';
import { connect } from 'react-redux';

class HoverCircle extends Component {

    constructor( props ) {
        super( props );

        this.state = {
            isVisible: false
        };
    }

    componentDidUpdate() {
        const { xPos, yPos } = this.props;
        const { isVisible } = this.state;

        if( !isVisible && xPos !== null && yPos !== null ) {
            this.setState({
               isVisible: true
            });
        }
    }

    shouldComponentUpdate(){
        const { xPos, yPos } = this.props;
        return xPos !== null && yPos !== null;
    }

    render() {
        const { xPos, yPos } = this.props;
        const { isVisible } = this.state;

        const style = {
            top: yPos,
            left: xPos,
            opacity: isVisible ? 1 : 0
        };

        return (
            <div className="bacteria-choice-circle" style={ style } />
        );
    }

}

const mapStateToProps = ( state ) => {
    return {
        xPos: state.choiceHover.xPos,
        yPos: state.choiceHover.yPos
    };
};

export default connect(mapStateToProps)(HoverCircle);


// WEBPACK FOOTER //
// ./src/components/hover-circle.js